import type { ReleaseNote } from "../release-types";

/**
 * Første utrulling (VIB-2832): hjelpesenteret og «Nytt i Revehiet» selv.
 * Dokumentarkivet er holdt utenfor og får egen utrulling. «Hold Revehiet
 * oppdatert» beskriver varselet om ny versjon (VIB-2834).
 */
export const HJELPESENTERET_2026_10: ReleaseNote = {
  id: "2026-10-07-hjelpesenteret",
  date: "2026-10-07",
  module: "Hjelp",
  title: "Hjelpesenteret og Nytt i Revehiet",
  intro:
    "Revehiet har fått et hjelpesenter under Hjelp i venstremenyen. Her får du også en kort forklaring hver gang noe nytt rulles ut.",
  themes: [
    {
      heading: "Nytt i Revehiet",
      items: [
        {
          title: "Én forklaring per utrulling",
          body: "Små justeringer underveis får ikke egen melding.",
        },
        {
          title: "En boks ved innlogging, én gang per utrulling",
          body: "«Les mer» tar deg hit.",
        },
      ],
    },
    {
      heading: "Hjelpesenteret",
      items: [
        {
          title: "Veiledninger for det du gjør hver dag",
          body: "De vanligste står først. Resten ligger under «Alle veiledninger».",
        },
        {
          title: "Søket leter i hele teksten",
          body: "Ikke bare i overskriftene.",
        },
      ],
    },
    {
      heading: "Hold Revehiet oppdatert",
      items: [
        {
          title: "Varsel når en ny versjon er ute",
          body: "Trykk «Last inn på nytt» når det passer. Siden laster aldri på nytt av seg selv.",
        },
        {
          title: "`⌘ Shift R` henter siste versjon med en gang",
          body: "Ctrl Shift R på Windows.",
        },
      ],
      images: [
        {
          src: "/nytt/2026-10-07-hjelpesenteret/versjonsvarsel.png",
          alt: "Varselet «Revehiet er oppdatert» med knappene «Senere» og «Last inn på nytt»",
          caption: "Slik ser varselet ut nederst på skjermen.",
        },
      ],
    },
  ],
  upcoming: [
    {
      title: "Egne utrullinger per del av systemet",
      body: "For eksempel tilbudsgeneratoren, og bare for dem det gjelder.",
    },
  ],
};
